import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  RuntimeException1r3t0zl97011n as RuntimeException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import {
  Channel3r72atmcithql as Channel,
  _ChannelResult___get_isSuccess__impl__odq1z912b5ogo8613be as _ChannelResult___get_isSuccess__impl__odq1z9,
  _ChannelResult___get_isClosed__impl__mg7kuu1g5u2zmbzbfb4 as _ChannelResult___get_isClosed__impl__mg7kuu,
  close$default1evna6yun3t5h as close$default,
  cancel$default1fq6eekptkf7a as cancel$default,
  SendChannel38sllbxw662ws as SendChannel,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (WebSocketChannelsConfig())();
        this_0.x5f_1 = this_0.a5j();
        this_0.y5f_1 = this_0.a5j();
        tmp.w5f_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var WebSocketChannelsConfigClass;
function WebSocketChannelsConfig() {
  if (WebSocketChannelsConfigClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.x5f_1 = Companion_getInstance_0().b5j_1;
        this.y5f_1 = Companion_getInstance_0().b5j_1;
      }
      a5j() {
        return Companion_getInstance_0().b5j_1;
      }
    }
    initMetadataForClass($, 'WebSocketChannelsConfig', WebSocketChannelsConfig);
    WebSocketChannelsConfigClass = $;
  }
  return WebSocketChannelsConfigClass;
}
function from(_this__u8e3s4, config) {
  // Inline function 'kotlin.with' call
  var tmp;
  if (config.c5j_1 === 2147483647) {
    tmp = Channel(2147483647);
  } else if (config.d5j_1.equals(ChannelOverflow_SUSPEND_getInstance())) {
    tmp = Channel(config.c5j_1, BufferOverflow_SUSPEND_getInstance());
  } else if (config.d5j_1.equals(ChannelOverflow_CLOSE_getInstance())) {
    tmp = new (BoundedChannel())(config.c5j_1);
  } else {
    // Inline function 'kotlin.error' call
    var message = 'Unsupported channel config.';
    throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.b5j_1 = new (ChannelConfig())(2147483647, ChannelOverflow_SUSPEND_getInstance());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ChannelConfigClass;
function ChannelConfig() {
  if (ChannelConfigClass === VOID) {
    class $ {
      constructor(capacity, onOverflow) {
        Companion_getInstance_0();
        this.c5j_1 = capacity;
        this.d5j_1 = onOverflow;
      }
      e5j() {
        return this.d5j_1.equals(ChannelOverflow_SUSPEND_getInstance()) && !(this.c5j_1 === 2147483647);
      }
    }
    initMetadataForClass($, 'ChannelConfig');
    ChannelConfigClass = $;
  }
  return ChannelConfigClass;
}
var ChannelOverflow_SUSPEND_instance;
var ChannelOverflow_CLOSE_instance;
var ChannelOverflow_entriesInitialized;
function ChannelOverflow_initEntries() {
  if (ChannelOverflow_entriesInitialized)
    return Unit_instance;
  ChannelOverflow_entriesInitialized = true;
  ChannelOverflow_SUSPEND_instance = new (ChannelOverflow())('SUSPEND', 0);
  ChannelOverflow_CLOSE_instance = new (ChannelOverflow())('CLOSE', 1);
}
var ChannelOverflowClass;
function ChannelOverflow() {
  if (ChannelOverflowClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ChannelOverflow');
    ChannelOverflowClass = $;
  }
  return ChannelOverflowClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      f5j(capacity) {
        var channel = {_v: null};
        var tmp = BufferOverflow_DROP_OLDEST_getInstance();
        // Inline function 'kotlin.also' call
        var this_0 = Channel(capacity, tmp, (it) => {
          var tmp;
          var tmp_0;
          if (channel._v == null) {
            throwUninitializedPropertyAccessException('channel');
          } else {
            tmp_0 = channel._v;
          }
          if (!tmp_0.z1a()) {
            var tmp_1;
            if (channel._v == null) {
              throwUninitializedPropertyAccessException('channel');
            } else {
              tmp_1 = channel._v;
            }
            tmp_1.q1b(ChannelOverflowException().j5j('Channel overflowed'));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        channel._v = this_0;
        return this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var BoundedChannelClass;
function BoundedChannel() {
  if (BoundedChannelClass === VOID) {
    class $ {
      constructor(capacity, delegate) {
        delegate = delegate === VOID ? Companion_instance_1.f5j(capacity) : delegate;
        this.k5j_1 = delegate;
      }
      l5j(element) {
        var result = this.k5j_1.h1b(element);
        if (!_ChannelResult___get_isSuccess__impl__odq1z9(result) && !_ChannelResult___get_isClosed__impl__mg7kuu(result)) {
          this.q1b(ChannelOverflowException().j5j('Channel overflowed'));
        }
        return result;
      }
      h1b(element) {
        return this.l5j(element);
      }
      *m5j(element, $completion) {
        yield* this.k5j_1.g1b(element, $completion);
        return Unit_instance;
      }
      g1b(element, $completion) {
        return this.m5j(element, $completion);
      }
      q1b(cause) {
        return this.k5j_1.q1b(cause);
      }
      v1b(handler) {
        this.k5j_1.v1b(handler);
      }
      z1a() {
        return this.k5j_1.z1a();
      }
      *n5j($completion) {
        return yield* this.k5j_1.j1b($completion);
      }
      j1b($completion) {
        return this.n5j($completion);
      }
      p1() {
        return this.k5j_1.p1();
      }
      qx(cause) {
        this.k5j_1.qx(cause);
      }
    }
    protoOf($).s1b = close$default;
    protoOf($).u1b = cancel$default;
    initMetadataForClass($, 'BoundedChannel', VOID, VOID, [SendChannel(), ReceiveChannel()], [1, 0]);
    BoundedChannelClass = $;
  }
  return BoundedChannelClass;
}
var ChannelOverflowExceptionClass;
function ChannelOverflowException() {
  if (ChannelOverflowExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static j5j(message) {
        var $this = this.ra(message);
        captureStack($this, $this.i5j_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ChannelOverflowException');
    ChannelOverflowExceptionClass = $;
  }
  return ChannelOverflowExceptionClass;
}
function ChannelOverflow_SUSPEND_getInstance() {
  ChannelOverflow_initEntries();
  return ChannelOverflow_SUSPEND_instance;
}
function ChannelOverflow_CLOSE_getInstance() {
  ChannelOverflow_initEntries();
  return ChannelOverflow_CLOSE_instance;
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1u99479g32m9i,
  ChannelOverflow_SUSPEND_getInstance as ChannelOverflow_SUSPEND_getInstance3qrqbtoutxinz,
  ChannelConfig as ChannelConfigftdbykui5s0q,
  WebSocketChannelsConfig as WebSocketChannelsConfig1qogztyrywmj9,
  from as from3gpkuvfyl3bft,
};
//endregion

//# sourceMappingURL=WebSocketChannelsConfig.mjs.map
